import React from 'react'
import { Link } from 'react-router-dom'

const Item = ({Obj}) => {
  return (
    <Link to={'edit/'+Obj.id}>
      <div className='form_item_row_container discription'>
        <div className='form_item_row_container_itemfull' style={{width:'25%'}}>
          <p>{Obj.title}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'20%'}}>
          <p>{Obj.typetext}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'20%'}}>
          <p>{Obj.slug}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'35%'}}>
          <p>{Obj.discription}</p>
        </div>
        <div className='form_item_row_container_item' style={{width:'20%'}}>
          <p>{Obj.parent}</p>
        </div>
      </div>
    </Link>
    
  )
}

export default Item
